import { jsxs as p, jsx as t } from "react/jsx-runtime";
import { Tooltip as b } from "@systemeio/ui";
import { useEditorState as g } from "../../node_modules/@tiptap/react/dist/index.mjs";
import { useMemo as h } from "react";
import { twMerge as u } from "tailwind-merge";
import { ToolbarButton as c } from "../../components/content-controls/toolbar-button.mjs";
import { getToolbarIconClassName as i, TOOLTIP_STYLES as f } from "../../constants/default-styles.mjs";
import m from "../../icons/indent-icon.mjs";
import { IndentProps as I } from "./indent.mjs";
import { useTranslation as x } from "../../i18n.mjs";
import { isImageSelected as N } from "../image-extension/utils/is-image-selected.mjs";
const T = (e) => {
  if (!e) return 0;
  const l = ["paragraph", "heading", "bulletList", "orderedList"];
  for (const n of l) {
    const o = e.getAttributes(n);
    if (o && typeof o.indent == "number")
      return o.indent;
  }
  return 0;
}, w = (e) => {
  const { t: l } = x(), n = g({
    editor: e,
    selector: ({ editor: s }) => ({
      isEditable: (s == null ? void 0 : s.options.editable) ?? !1,
      currentIndent: T(s),
      isImageSelected: N(s)
    })
  }), o = (n == null ? void 0 : n.currentIndent) ?? 0, a = !(n != null && n.isEditable) || !!(n != null && n.isImageSelected) || o <= I.min, r = !(n != null && n.isEditable) || !!(n != null && n.isImageSelected) || o >= I.max;
  return h(() => {
    const s = () => e == null ? void 0 : e.chain().focus().outdent().run(), d = () => e == null ? void 0 : e.chain().focus().indent().run();
    return [
      {
        toolbarRender: /* @__PURE__ */ t(
          b,
          {
            disabled: a,
            label: l("decrease_intent"),
            ...f,
            children: /* @__PURE__ */ t(c, { className: "flex gap-1", onClick: s, disabled: a, children: /* @__PURE__ */ t(m, { className: i(a) }) })
          },
          "outdent"
        ),
        tooltipRender: /* @__PURE__ */ p(c, { className: "flex gap-1", onClick: s, disabled: a, children: [
          /* @__PURE__ */ t(m, { className: i(a) }),
          l("decrease_intent")
        ] })
      },
      {
        toolbarRender: /* @__PURE__ */ t(
          b,
          {
            disabled: r,
            label: l("increase_intent"),
            ...f,
            children: /* @__PURE__ */ t(c, { className: "flex gap-1", onClick: d, disabled: r, children: /* @__PURE__ */ t(
              m,
              {
                className: u(i(r), "rotate-180")
              }
            ) })
          },
          "indent"
        ),
        tooltipRender: /* @__PURE__ */ p(c, { className: "flex gap-1", onClick: d, disabled: r, children: [
          /* @__PURE__ */ t(m, { className: u(i(r), "rotate-180") }),
          l("increase_intent")
        ] })
      }
    ];
  }, [e, r, a, l]);
};
export {
  w as useIndentExtensionToolbar
};
